import { AxiosInstance, RawAxiosResponseHeaders } from "axios";
import {
  Organization,
  UpdateOrganizationInput,
  CreateOrganizationInput,
} from "@/types/organization";
import { client } from "@/api/client";
import { authHeaders } from "@/hoc/authHeaders";

export async function fetchOrganization(url: string): Promise<Organization> {
  const headers = await authHeaders();
  const { data } = await client
    .get(url, {
      headers,
    })
    .catch((error) => {
      throw new Error(error.response.message);
    });
  return data;
}

export interface OrganizationRepository {
  updateOrganization(id: string, data: UpdateOrganizationInput): Promise<void>;

  createOrganization(
    data: CreateOrganizationInput
  ): Promise<RawAxiosResponseHeaders>;
}

class OrganizationRepositoryImpl implements OrganizationRepository {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async createOrganization(
    data: CreateOrganizationInput
  ): Promise<RawAxiosResponseHeaders> {
    const response = await this.client
      .post<CreateOrganizationInput>(`/api/v1/organizations`, data)
      .catch((error) => {
        throw error.response.status;
      });

    return response.headers;
  }

  async updateOrganization(
    id: string,
    data: UpdateOrganizationInput
  ): Promise<void> {
    const headers = await authHeaders();
    await this.client
      .put<UpdateOrganizationInput>(`/api/v1/organizations/${id}`, data, {
        headers,
      })
      .catch((error) => {
        if (error.response.status === 409) {
          throw new Error("内容が重複しております");
        } else {
          throw new Error(error.response.message);
        }
      });
  }
}

export function newOrganizationRepository(
  client: AxiosInstance
): OrganizationRepository {
  return new OrganizationRepositoryImpl(client);
}
